import { render, staticRenderFns } from "./UpdateWorkshop.vue?vue&type=template&id=d942753e&scoped=true"
import script from "./UpdateWorkshop.vue?vue&type=script&lang=js"
export * from "./UpdateWorkshop.vue?vue&type=script&lang=js"
import style0 from "./UpdateWorkshop.vue?vue&type=style&index=0&id=d942753e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d942753e",
  null
  
)

export default component.exports